import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-24 px-4 bg-navy-900" data-id="element-173">
      <div className="max-w-3xl mx-auto" data-id="element-174">
        <FadeIn data-id="element-175">
          <div className="flex items-center gap-4 mb-10" data-id="element-176">
            <div className="h-[1px] flex-1 bg-gold/20" data-id="element-177" />
            <h2 className="text-sm tracking-[0.2em] uppercase text-gold font-sans font-semibold" data-id="element-178">
              El Problema
            </h2>
            <div className="h-[1px] flex-1 bg-gold/20" data-id="element-179" />
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-180">
          <div className="bg-navy-700/50 border-l-4 border-gold p-8 md:p-10 rounded-r-2xl shadow-xl" data-id="element-181">
            <p className="text-lg md:text-xl text-cream mb-6 leading-relaxed" data-id="element-182">
              La mayoría de los libros de sueño fueron escritos para padres que
              están en casa todo el día. Te dicen que observes "señales sutiles"
              que tú no puedes ver porque estás trabajando. Te proponen rutinas
              imposibles que no encajan con los horarios rígidos de las
              guarderías americanas (Daycares).
            </p>
            <p className="text-lg md:text-xl text-muted leading-relaxed" data-id="element-183">
              El resultado es un bebé sobre-estimulado por las luces, el ruido y
              los cambios de horario entre el centro de cuidado y la casa. Ese
              caos se traduce en despertares nocturnos cada 2 horas que te están
              destruyendo por dentro.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}